export default "__VITE_ASSET__5c9ba44b__"